module.exports = __webpack_public_path__ + "871eca5d37aab3f01548f12e7093dca2.jpg";